module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/hand_package_icon-4f3b47ac42c93b1deabc90fcec788972.svg";